import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip } from "@mui/material";
import { formatAmount } from '../../helper';
import SectionHeader from '../../Pages/admin/shared/SectionHeader';

/* Shop Partnership viewer — BY ACCOUNT.
 *
 * The same rows read the other way round: one block per account, listing the shops it is on. This
 * answers "what is Khadim on, and at what rate" without re-querying, which is the question the
 * by-shop view cannot answer in one glance.
 *
 * The percentages in this view deliberately have NO total. Each one is a share of a DIFFERENT
 * shop's profit, so adding them would produce a number that means nothing — 25% of one shop plus
 * 25% of another is not 50% of anything.
 */
const HEAD = { background: '#f1f1f1', color: '#111827', fontWeight: 600 };

class ByAccount extends Component {
    render() {
        const { rows, asAtLabel } = this.props;

        return (
            <section>
                <SectionHeader title={<>{asAtLabel}</>} />

                {rows.length === 0 && (
                    <Row><Col md={12}>
                        <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                            No accounts hold a partnership or card in this view.
                        </div>
                    </Col></Row>
                )}

                {rows.map((acc) => (
                    <Row key={acc.AccountID} style={{ marginBottom: 18 }}>
                        <Col md={12}>
                            <div style={{ padding: '10px 4px 4px', display: 'flex', alignItems: 'center', gap: 10 }}>
                                <strong style={{ color: '#4842a7', fontSize: 15 }}>{acc.AccountTitle}</strong>
                                <span style={{ color: '#64748b', fontSize: 13 }}>
                                    {acc.partnerShops} shop{acc.partnerShops === 1 ? '' : 's'} as partner
                                    {acc.cardShops > 0 ? `, ${acc.cardShops} as card holder` : ''}
                                </span>
                                {acc.isOrphan && (
                                    <Chip size="small" color="error" label="this account no longer exists" />
                                )}
                            </div>

                            <Paper>
                                <TableContainer className="report-table-container">
                                    <Table className="report-table" size="small" aria-label={acc.AccountTitle}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={HEAD}>Shop</TableCell>
                                                <TableCell style={HEAD}>Type</TableCell>
                                                <TableCell style={{ ...HEAD, textAlign: 'right' }}>Percentage</TableCell>
                                                <TableCell style={HEAD}>From</TableCell>
                                                <TableCell style={HEAD}>To</TableCell>
                                                <TableCell style={HEAD}>Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {acc.links.map((l) => (
                                                <TableRow className="table-rows" key={l.kind + l.RowID}
                                                    sx={{ '&:last-child td': { border: 0 } }}>
                                                    <TableCell className="report-label-cell">{l.ShopName}</TableCell>
                                                    <TableCell>{l.kind === 'p' ? 'Partner' : 'Card'}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>
                                                        {l.kind === 'p'
                                                            ? <strong>{formatAmount(l.Pct)}%</strong>
                                                            : <span style={{ color: '#94a3b8' }}>—</span>}
                                                    </TableCell>
                                                    <TableCell>{l.WindowFrom}</TableCell>
                                                    <TableCell>{l.WindowTo}</TableCell>
                                                    <TableCell>{+l.LiveToday ? 'live' : 'not current'}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Col>
                    </Row>
                ))}
            </section>
        );
    }
}

export default ByAccount;
